import {
  Box,
  Checkbox,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Textarea,
  useBoolean,
} from '@chakra-ui/react';
import React, { PropsWithChildren } from 'react';

import { AgreeButton } from '../../../components/StyledButton';
import { useSizeContext } from '../../SizeProvider';

type ConsentModalProps = PropsWithChildren<{
  isOpen?: boolean;
  onClose: Runnable;
  onSubmit: Runnable;
}>;

const consentContent = `
【個人情報等の取り扱いに関して】

本システムでは、ユーザーの個人情報等の取扱いについて、下記のとおり致します。

１．個人情報の利用目的について
本システムでは、お客様からご提示いただいた名前、住所、電話番号、性別その他のお客様個人に関わる情報（以下、「個人情報等」といいます）を、お客様へ適した商品やサービス、及び会報誌・ダイレクトメール等による各種情報のご提供のために利用させていただき、お客様の承諾なく、他の目的には利用いたしません。

２．個人情報の第三者提供について
本システムでお預かりした個人情報等を、以下のいずれかに該当する場合を除き、第三者へ提供、取り扱いを委託することはありません。
①お客様の事前の承諾を得た場合
②業務委託会社に対して、お客様に明示した利用目的の達成のために必要な範囲で個人情報等の取扱いを委託する場合
③法令の定めにより提供を求められた場合

３．個人情報の開示等について
本システムでは、個人情報等の開示、変更、削除の求めがあった場合には、お客様ご本人であることをご確認させていただいたうえで、すみやかに対応いたします。`;

/**
 * 初回ログイン時のみ表示される個人情報同意ダイアログ
 *
 * @returns モーダル
 */
export const ConsentModal: React.FunctionComponent<ConsentModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
}) => {
  const [isChecked, { toggle }] = useBoolean(false);
  const sizes = useSizeContext();

  return (
    <Modal isOpen={!!isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader fontSize={sizes.fontSize.modalHeader}>
          個人情報同意
        </ModalHeader>
        <ModalBody fontSize={sizes.fontSize.modalBody}>
          <Textarea readOnly height={'16rem'} fontSize={'0.75rem'}>
            {consentContent}
          </Textarea>
        </ModalBody>
        <Flex justify="center">
          <Checkbox checked={isChecked} onChange={toggle}>
            <Box as="p" fontSize={sizes.fontSize.confirmMessage}>
              上記内容を確認しました
            </Box>
          </Checkbox>
        </Flex>
        <ModalFooter justifyContent="center">
          <AgreeButton isDisabled={!isChecked} onClick={onSubmit} />
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
